<template>
  <div v-if="showPwaInstall && pwaShowPwaInstall" class="pwa-home">
    <div class="pwa-home-bg" :style="pwaHomeStyle"></div>
    <pwa-install-top>
      <template #customerBtn>
        <p class="pwa-home-text">{{ letter.v3AddShortcutForBonus }}</p>
        <a
          class="pwa-home-close"
          href="javascript:void(0)"
          @click="handleHeaderPwaInstall(false)"
          >&times;</a
        >
      </template>
    </pwa-install-top>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import globalConfig from '@utiles/officialStore/globalConfig';
import { isSafari } from '@utiles/officialStore/device';
import PwaInstallTop from '@components/officialTopupNew/pwa/PwaInstallTop.vue';
import { SET_PWA_STATUS } from '@store/officialTopupNew/activity';
import { UPDATE_IS_INSTALL } from '@store/officialTopupNew/page';

export default {
  name: 'PwaInstallHome',
  components: { PwaInstallTop },
  data() {
    return {
      isSafari: isSafari(),
      isHideAdd:
        globalConfig.getHrefParam('cid') === 'shortcut' ||
        globalConfig.getHrefParam('scid').includes('shortcut')
    };
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      picList: state => state.page.picList,
      showPwaInstall: state => state.activity.showPwaInstall,
      isInstall: state => state.page.isInstall,
      openPwa: state => state.page.openPwa
    }),
    ...mapGetters(['isJpPlatform']),
    pwaHomeStyle() {
      return `background-image: url(${this.picList.mPwa})`;
    },
    pwaShowPwaInstall() {
      return (
        this.openPwa &&
        !this.isHideAdd && // pwa进入不展示
        (this.isSafari || !this.isInstall?.value) && // 已安装不展示，safari展示
        !this.isJpPlatform // 日本平台不展示
      );
    }
  },
  methods: {
    handleHeaderPwaInstall(state) {
      this.$store.commit(SET_PWA_STATUS, state);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopupNew/_dimen.scss';
.pwa-home {
  box-sizing: border-box;
  z-index: 30;
  position: relative;
  width: 100%;
  height: 120px;
  margin: 30px auto 0;
  padding: 0 40px;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;

  &-bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: calc(100% - 80px);
    height: 100%;
    margin: auto;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: right 52%;
    border-radius: 10px;
  }

  &-text {
    z-index: 1;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 30px;
    right: 110px;
    width: 330px;
    height: 68px;
    line-height: 1.2;
    font-size: 22px;
    font-weight: bold;
    text-align: center;
    color: #fff;
  }

  &-close {
    z-index: 3;
    box-sizing: border-box;
    position: absolute;
    right: 0;
    top: 0;
    width: 44px;
    height: 44px;
    padding-left: 10px;
    padding-top: 2px;
    background-color: rgba(0, 0, 0, 0.7);
    color: #fff;
    font-size: 34px;
    font-weight: normal;
    text-align: center;
    border-radius: 0 12px 0 60px;
  }
}

::v-deep .pwa-install-wrap {
  z-index: 2;
  position: relative;
}

@media screen and (min-width: 768px) {
  .pwa-home {
    &-text {
      right: 210px;
    }
  }
}
</style>
